import React from 'react'
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
function ResponsiveSidebar({children, heading, isMobile}) {
  return (
    <>
      {isMobile ? (
        <Accordion className="mobile-sidebar-accordion">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel-content"
            id="panel-header"
            className="mobile-accordion-header"
          >
            {heading}
          </AccordionSummary>
          <AccordionDetails>{children}</AccordionDetails>
        </Accordion>
      ) : (
        children
      )}
    </>
  );
}

export default ResponsiveSidebar